import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import TallExhibitionist from './TallExhibitionist';
import ExhibitionistBox, {
  ExhibitionistBoxProps,
  ExhibitionistBoxType,
} from '../_partials/ExhibitionistBox';
import ExhibitionistEmptyState from '../_partials/ExhibitionistEmptyState';

import s from './TallExhibitionist.scss';

class TallExhibitionistBox extends React.Component<
  ExhibitionistBoxProps & WithTranslation
> {
  render() {
    return (
      <ExhibitionistBox
        {...this.props}
        exhibitionistType={ExhibitionistBoxType.TALL}
        emptyView={
          <ExhibitionistEmptyState
            moduleId={this.props.moduleId}
            view="small"
            className={s['empty-state']}
            exhibitionistType={ExhibitionistBoxType.TALL}
          />
        }
      >
        {boxProps => <TallExhibitionist {...boxProps} />}
      </ExhibitionistBox>
    );
  }
}

export default withTranslation()(
  TallExhibitionistBox
) as React.ComponentType<{}>;
